export const GET_EXTRACTIONS = 'GET_EXTRACTIONS';
export const EXTRACTIONS_UPDATED = 'EXTRACTIONS_UPDATED';